<template>
    <div class="layout">
        <div class="layout__header">
            <div class="layout__title">
                <h3>Administración de asignación de usuarios</h3>
            </div>
        </div>
        <k-table 
            ref="table"
            :filterStatus="false"
            :createButton="false"
            :editButton="false"
            :deleteButton="false"
            @editar="editar"
            :path="url"
            :buttons="[
                {
                    text : '',
                    class : 'btn-info',
                    icon : 'fa-edit',
                    event : 'editar'
                }
            ]"
            :columns="[
                {
                    display : 'Nombre',
                    value : 'nombre'
                },
                {
                    display : 'Usuario',
                    value : 'nombre_usuario'
                },
                {
                    display : 'E-mail',
                    value : 'email'
                }
            ]"
        ></k-table>
        <modal width="70%" height="auto" name="administrarUsuario" scrollable>
            <usuario-empresa @updated="updatedUsuario" v-model="selectedUsuario"></usuario-empresa>
        </modal>
    </div>
</template>

<script>
export default {
    data : function () {
        return {
            url : url + '/usuarios/administrar',
            selectedUsuario : null
        }
    },
    methods : {
        editar : function (usuario) {
            this.selectedUsuario = usuario;
            this.$modal.show('administrarUsuario');
        },
        updatedUsuario : function () {
            this.$refs.table.loadRows();
            this.$modal.hide('administrarUsuario');
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/usuarios/AdministracionUsuarios.vue